import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMov48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="mov">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23C1 21.3431 2.34315 20 4 20H35C36.6569 20 38 21.3431 38 23V33C38 34.6569 36.6569 36 35 36H4C2.34315 36 1 34.6569 1 33V23ZM4 22C3.44772 22 3 22.4477 3 23V33C3 33.5523 3.44772 34 4 34H35C35.5523 34 36 33.5523 36 33V23C36 22.4477 35.5523 22 35 22H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 5C9 2.23858 11.2386 0 14 0H32C32.2589 0 32.5078 0.100428 32.6941 0.280156L46.6941 13.7802C46.8896 13.9686 47 14.2285 47 14.5V43C47 45.7614 44.7614 48 42 48H14C11.2386 48 9 45.7614 9 43V35H11V43C11 44.6569 12.3431 46 14 46H42C43.6569 46 45 44.6569 45 43V15.5H34C32.3431 15.5 31 14.1569 31 12.5V2H14C12.3431 2 11 3.34315 11 5V21H9V5ZM33 3.35347L43.5223 13.5H34C33.4477 13.5 33 13.0523 33 12.5V3.35347Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M13.0111 32L12.9991 26.96L10.5271 31.112H9.65109L7.19109 27.068V32H5.36709V23.6H6.97509L10.1191 28.82L13.2151 23.6H14.8111L14.8351 32H13.0111ZM20.896 32.144C20.024 32.144 19.236 31.956 18.532 31.58C17.836 31.204 17.288 30.688 16.888 30.032C16.496 29.368 16.3 28.624 16.3 27.8C16.3 26.976 16.496 26.236 16.888 25.58C17.288 24.916 17.836 24.396 18.532 24.02C19.236 23.644 20.024 23.456 20.896 23.456C21.768 23.456 22.552 23.644 23.248 24.02C23.944 24.396 24.492 24.916 24.892 25.58C25.292 26.236 25.492 26.976 25.492 27.8C25.492 28.624 25.292 29.368 24.892 30.032C24.492 30.688 23.944 31.204 23.248 31.58C22.552 31.956 21.768 32.144 20.896 32.144ZM20.896 30.488C21.392 30.488 21.84 30.376 22.24 30.152C22.64 29.92 22.952 29.6 23.176 29.192C23.408 28.784 23.524 28.32 23.524 27.8C23.524 27.28 23.408 26.816 23.176 26.408C22.952 26 22.64 25.684 22.24 25.46C21.84 25.228 21.392 25.112 20.896 25.112C20.4 25.112 19.952 25.228 19.552 25.46C19.152 25.684 18.836 26 18.604 26.408C18.38 26.816 18.268 27.28 18.268 27.8C18.268 28.32 18.38 28.784 18.604 29.192C18.836 29.6 19.152 29.92 19.552 30.152C19.952 30.376 20.4 30.488 20.896 30.488ZM34.7478 23.6L31.1118 32H29.1918L25.5678 23.6H27.6678L30.2238 29.6L32.8158 23.6H34.7478Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
